import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PortalTotalTravelTimeNode } from '@app/services/api/api.types';

@Component({
  selector: 'layover-badge',
  templateUrl: './layover-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoverBadgeComponent {
  @Input() stops: number;
  @Input() travelTime: PortalTotalTravelTimeNode;
}
